import React from 'react'
import { Accordion, AccordionWrapper } from '../seo-content/seo_content'
import { Helmet } from "react-helmet";
import { withAppContext } from 'src/store/initAppContext';
import AviatorSEO39 from './AviatorSEO39';
import AviatorF88 from './AviatorF88';
import { Link } from 'react-router-dom';
import { getDamain } from 'src/util/commonfun';
import AviatorSEO31 from './AviatorSEO31';

const AviatorSEO = (props) => {
    const { app: { brandId } } = props;

    let domainURL = getDamain(brandId);

    const domain = (brandId === 31 || brandId === 32) ? 'Yolo247' : brandId === 33 ? 'IW247' : (brandId === 39 || brandId === 40) ? 'FOMO7' : (brandId === 46 || brandId === 47) ? 'FUN88' : 'Betdaily';

    return (brandId === 40 || brandId === 46) ? <></> : (
        <>
            <AccordionWrapper>
                <Accordion>
                    <input type="checkbox" id="section1" className="accordion__input" />
                    <label htmlFor="section1" className="accordion__label">{
                        (brandId == 39 || brandId == 40) ? <h1>Play Aviator Game by Spribe</h1> : 
                        (brandId == 46 || brandId == 47) ? <h1>Play Aviator Game Online at FUN88!</h1> : 
                        <h1>Aviator Game Online in India: Play and Win</h1>
                    }</label>
                    {
                        (brandId == 39 || brandId == 40) ? <AviatorSEO39 /> : 
                        (brandId == 46 || brandId == 47) ? <AviatorF88 /> : 
                        <AviatorSEO31 />
                    }
                </Accordion>
            </AccordionWrapper>
        </>
    )
}

export default withAppContext(AviatorSEO);